<template>
    <div class="content-form" id="form-contact">
        <div class="content-form-item container row">
            <form ref="formContact" class="col-md-6" @submit.prevent="sendForm">
                <div>
                    <h1 class="v-content-form" v-contentForm="{ section: 'Form', removeHtml: true }">Contacte-nos</h1>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                        <input
                            type="text"
                            class="form-control"
                            id="name"
                            v-model="formData.name"
                            required
                        />
                        <span class="hide v-content-form" v-contentForm="{ section: 'Form', removeHtml: true }">Nome</span>
                        </div>
                    </div>
                </div>
                <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                    <input
                        type="email"
                        class="form-control"
                        id="email"
                        v-model="formData.email"
                        required
                    />
                    <span class="hide v-content-form" v-contentForm="{ section: 'Form', removeHtml: true }">Email</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                    <input
                        type="phone"
                        class="form-control"
                        id="phone"
                        v-model="formData.phone"
                        @keydown="onlyNumbers"
                        required
                    />
                    <span class="hide v-content-form" v-contentForm="{ section: 'Form', removeHtml: true }">Telemóvel</span>
                    </div>
                </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                        <textarea
                            class="form-control"
                            id="message"
                            v-model="formData.message"
                            required
                            ></textarea>
                        <span class="hide v-content-form" v-contentForm="{ section: 'Form', removeHtml: true }">Mensagem</span>
                        </div>
                    </div>
                </div>
                <div class="content-input-check">
                    <input
                        type="checkbox"
                        name="terms"
                        unchecked-value="false"
                        required="required"
                        v-model="formData.accepted_contact"
                    />
                    <label class="v-content-form" v-contentForm="{ section: 'Form', removeHtml: true }">
                        Aceito ser contatado(a) para dar continuidade ao meu pedido, assim como, o uso dos meus dados para os fins a que se destina este contacto    
                    </label>
                </div>
                <div class="recaptcha">
                    <div class="g-recaptcha" data-sitekey="6LckZzIpAAAAAGaMLV9vgzOtdngWn0h79WzWzWKd"></div>
                </div>
                <div class="send-btn">
                    <button type="submit" class="v-content-form" v-contentForm="{ section: 'Form', removeHtml: true }">submeter</button>
                </div>
            </form>
        </div>
        <img src="@/assets/img/merchant/contact.png" alt="">
    </div>
  </template>
  
  <script>
  import { mapState, mapActions } from "vuex";
  import axios from 'axios';
  import store from '@/store';
  
  const allContents = [];
  const lang = localStorage.getItem('locale') || 'es';
  
  export default {
    name: 'Form',
    data() {
      return {
        formData: {
          name: '',
          phone: '',
          email: '',
          message: '',
          accepted_contact: '',
          type: 'client',
        },
      }
    },
    computed: {
      ...mapState('App', ['loading']),
      ...mapActions('App', ['loading']),
    },
    methods: {
      onlyNumbers(event) {
        // Permite teclas de controle
        if (
            event.key === 'Backspace' ||
            event.key === 'Delete' ||
            event.key === 'ArrowLeft' ||
            event.key === 'ArrowRight' ||
            event.key === 'Tab'
        ) {
            return;
        }

        // Bloqueia se não for número
        if (event.key.length === 1 && !/[0-9]/.test(event.key)) {
            event.preventDefault();
            return;
        }

        // Bloqueia se já tiver 9 dígitos
        if (this.formData.phone.length >= 9) {
            event.preventDefault();
        }
      },
      async sendForm(){            
          await axios({
              method: 'POST',
              url: '/api/v1/site/contact',
              data: this.formData
          }).then(response => {
              if(response.data.status == 'success'){
                  this.$swal({
                      title: 'Sucesso!',
                      text: response.data.data.message,
                      icon: 'success',
                      confirmButtonText: 'OK',
                      confirmButtonColor: '#3EAD7C',
                  }).then(() => {
                      this.formData = {
                          name: '',
                          phone: '',
                          email: '',
                          message: '',
                          accepted_contact: '',
                      };
                  });
              }else{
                  this.$swal({
                      title: 'Erro!',
                      text: 'Ocorreu um erro ao enviar o seu pedido!',
                      icon: 'error',
                      confirmButtonText: 'OK',
                      confirmButtonColor: '#3EAD7C',
                  });
              }
          }).catch(error => {
              console.log(error);
          });
      },
      updateDirectives() {
          const allElements = document.querySelectorAll('.v-content-home');
          allContents.splice(0, allContents.length); // clear the contents array
          allElements.forEach((el) => {
              const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
              params.content = el.innerHTML.trim();
              (!('type' in params) ? params.type = 'text' : null);
              params.theme = process.env.VUE_APP_THEME;
              params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
              allContents.push(params);
          });
      },
    },
    created() {
      this.updateDirectives();
      this.formData.type = 'client';
    },
    directives: {
      contentForm: {
        inserted: async function (el, binding) {
          const allElements = document.querySelectorAll('.v-content-form');
          let params = binding.value ? binding.value : {};
          params.content = el.innerHTML.trim();
          (!('type' in params) ? params.type = 'text' : null);
          params.theme = process.env.VUE_APP_THEME;
          params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
          allContents.push(params);
  
          if (allElements.length == allContents.length) {
            store.dispatch('App/loading', true);
            await axios({
              method: "POST",
              url: '/api/v1/site/get-all-contents',
              data: { allContents, lang }
            })
              .then(response => response.data)
              .then((data) => {
                document.getElementById('name').placeholder = sanitizeHtml(data.data[1]);
                document.getElementById('email').placeholder = sanitizeHtml(data.data[2]);
                document.getElementById('phone').placeholder =sanitizeHtml(data.data[3]);
                document.getElementById('message').placeholder = sanitizeHtml(data.data[4]);
  
                function sanitizeHtml(value) {
                  const doc = new DOMParser().parseFromString(value, 'text/html');
                  return doc.body.textContent || "";
                }
  
                const allElements = document.querySelectorAll('.v-content-form');
                allContents.forEach((el) => {
                  if (el.type == 'text') {
                    allElements.forEach((el, index) => {
                      el.innerHTML = data.data[index];
                    });
                  }
                });
                store.dispatch('App/loading', false);
              });
          }
        },
  
      }
    },
  };
  </script>
  
  <style lang="scss">
  .content-form {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    margin: 100px 0;
    @media screen and (max-width: 991px) {
      height: auto;
      margin: 50px 0;
    }
    img{
        position: absolute;
        left: 0;
        width: 100%;
        max-width: 50%;
        @media screen and (max-width: 991px) {
            display: none;
        }
    }
    &-item {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      form {
        width: 100%;
        @media screen and (max-width: 991px) {
          flex: 0 0 100%;
          max-width: 100%;
        }
        h1 {
          font-family: "Font Bold";
          font-size: 45px;
          line-height: 60px;
          color: var(--main-color);
          text-align: left;
          margin-bottom: 45px;
          @media screen and (max-width: 991px) {
            font-size: 40px;
            line-height: 50px;
            text-align: left;
          }
        }
        .form-group {
          margin-bottom: 15px;
          input {
            width: 100%;
            height: 70px;
            border: 1px solid var(--dark-gray);
            border-radius: 10px;
            padding: 0 30px;
            outline: none;
            font-family: "Font Regular";
            font-size: 30px;
            line-height: 40px;
            color: var(--dark-gray);
            &::placeholder {
              font-family: "Font Regular";
              font-size: 30px;
              line-height: 40px;
              color: var(--dark-gray);
              @media screen and (max-width: 991px) {
                font-size: 13px;
              }
            }
            &:focus, &:active, &:hover {
              box-shadow: none!important;
            }
            @media screen and (max-width: 991px) {
                height: 50px;
                font-size: 13px;
                padding: 0 15px;
            }
          }
          textarea{
            all: unset;
            display: flex;
            height: 146px;
            width: calc(100% - 40px);
            border-radius: 10px;
            outline: none;
            border: 1px solid var(--dark-gray);
            text-align: left;
            font-family: 'Font Regular';
            padding: 20px;
            font-size: 30px;
            line-height: 40px;
            color: var(--dark-gray);
            @media screen and (max-width: 991px){
              font-size: 18px; 
              line-height:30px;
              padding: 15px;             
            }
            &::placeholder {
              font-family: "Font Regular";
              font-size: 30px;
              line-height: 40px;
              color: var(--dark-gray);
              @media screen and (max-width: 991px) {
                font-size: 13px;
              }
            }
            &:focus, &:active, &:hover {
                box-shadow: none!important;
                outline: none!important;
            }
          }
        }
      }
    }
  }
  .content-input-check {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      @media screen and (max-width: 991px) {
          align-items: flex-start;
      }
  }
  
  .content-input-check input[type=checkbox] {
      position: relative;
      height: 30px;
      width: 30px;
      border-radius: 15px;
      border: 1px solid #787878;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      outline: 0!important;
      margin: 0;
      margin-right: 20px;
      @media screen and (max-width: 991px) {
          margin-top: 10px;
      }
  }
  .content-input-check input[type=checkbox]:checked:before {
      content: "";
      height: 100%;
      width: 100%;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAOCAYAAADNGCeJAAAABHNCSVQICAgIfAhkiAAAALFJREFUOE+l07ENwjAQBdD/YYCsEjFBkKCHTehpQ59NoKeAETICKzAAOXwWiRLLCb7EjV3YT77vM7Fw5Jd9vgKuDXDkEstDIg8S/IDFbCyE6vO9noXFIK3QjI1BZmwKMmH/II/pJl1ogGMvmwJ5bFPuXm7OGnIbA1Oh7mZryFMEEoIWqMtMD4WgFRo8QB8k5CRg1Xb2VJ79nAd91oIuygyQt36RVCjaGr/ybi6/gwVS7Au7OIxjcNg7ngAAAABJRU5ErkJggg==);
      background-position: 50%!important;
      background-repeat: no-repeat!important;
  }
  .content-input-check input[type=checkbox]:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      border-radius: 10px;
      border: 0;
  }
  .content-input-check label {
      font-size: 16px;
      line-height: 26px;
      font-family: 'Font Regular';
      color: var(--dark-gray);
      width: calc(100% - 65px);
      text-align: left;
      padding-top: 2px;
      margin-bottom: 0;
      @media screen and (max-width: 991px) {
          font-size: 13px;
      }
  }
  .recaptcha {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 30px;
    @media screen and (max-width: 991px) {
        justify-content: center;
    }
  }
  
  .send-btn {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @media screen and (max-width: 991px) {
        justify-content: center;
    }
    button {
      width: 328px;
      height: 71px;
      border: 1px solid var(--main-color);
      border-radius: 10px;
      font-family: "Font Medium";
      text-transform: uppercase;
      color: var(--white);
      font-size: 30px;
      line-height: 46px;
      background-color: var(--main-color);
      &:hover {
          color: var(--main-color);
          background: var(--white);
      }
      @media screen and (max-width: 991px) {
          font-size: 16px;
          line-height: 26px;
      }
      @media screen and (max-width: 576px) {
        width: 100%; 
      }
    }
  }
  .hide{
    color: transparent;
    font-size: 0;
  }
  </style>
  